<!-- =========================================================================================
    File Name: VxTimeline.vue
    Description: Timeline Component
    Component Name: VxTimeline
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <ul class="vx-timeline" v-if="data.length > 0">
    <li v-for="item in data" :key="item._id">
      <div class="timeline-icon" :class="getColor(item.type)">
        <feather-icon :icon="getIcon(item.type)" svgClasses="text-white stroke-current w-5 h-5" />
      </div>
      <div class="timeline-info">
        <p class="font-semibold">{{ item.event }}</p>
        <span class="activity-desc">{{ item.desc }}</span>
      </div>
      <small class="text-grey activity-e-time">{{ item.date | moment('from', 'now') }}</small>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'vx-timeline',
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  methods: {
    getIcon (type) {
      switch (type) {
      case 'success':
        return 'CheckCircleIcon'
      case 'fail':
        return 'XCircleIcon'
      case 'info':
        return 'InfoIcon'
      default:
        return 'ActivityIcon'
      }
    },
    getColor (type) {
      switch (type) {
      case 'success':
        return 'bg-success'
      case 'fail':
        return 'bg-danger'
      case 'info':
        return 'bg-warning'
      default:
        return 'bg-primary'
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
